import { render } from "./OnlineRoom.vue?vue&type=template&id=2cec4387"
import script from "./OnlineRoom.vue?vue&type=script&lang=js"
export * from "./OnlineRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__